import { ACCESS_CODES } from 'utils/sitePreferenceHelpers'

export const DIGITAL_WELL_BEING_PRODUCT_NAME = 'digital-well-being'

export const LESSONS_DASHBOARD_PATHS = {
  elementary: '/dashboard/grades-k-5',
  'middle-school': '/dashboard/grades-6-8',
  [DIGITAL_WELL_BEING_PRODUCT_NAME]: '/dashboard',
}
export const UNIT_ROUTE_PRODUCT_NAMES = [
  'elementary',
  'middle-school',
  DIGITAL_WELL_BEING_PRODUCT_NAME,
]

export const LESSONS_PROGRAM_CONFIG = {
  elementary: {
    instructorKey: 'K5SelDigital',
    activeSiteKey: 'elementaryActiveSiteId',
    preferencesAccessCode: ACCESS_CODES.K5,
  },
  'middle-school': {
    instructorKey: 'MspDigital',
    activeSiteKey: 'middleSchoolActiveSiteId',
    preferencesAccessCode: ACCESS_CODES.MSP,
  },
  [DIGITAL_WELL_BEING_PRODUCT_NAME]: {
    instructorKey: 'Dwb',
    activeSiteKey: 'digitalWellBeingActiveSiteId',
  },
}

export const PROGRAM_COURSE_TREE_CONFIG = {
  elementary: {
    contentGroupCode: 'k5SelDigital',
    tier1Grades: ['K', '1', '2', '3', '4', '5'],
    tier2CurriculumTypes: ['k-2_curriculum_tier2', '3-5_curriculum_tier2'],
  },
  'middle-school': {
    contentGroupCode: 'mspDigital',
    tier1Grades: ['6', '7', '8'],
    tier2CurriculumTypes: ['6-8_curriculum_tier2'],
  },
  [DIGITAL_WELL_BEING_PRODUCT_NAME]: {
    contentGroupCode: 'dwb',
  },
}
